import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { ApiUrlContext } from "../App";

function RegisterPage({ onAuth }) {
  const apiUrl = useContext(ApiUrlContext);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [parentEmail, setParentEmail] = useState("");
  const [error, setError] = useState([]);
  const [success, setSuccess] = useState(false);

  const calculateAge = (dateStr) => {
    if (!dateStr) return null;
    const dob = new Date(dateStr);
    if (isNaN(dob.getTime())) return null;
    const diff = Date.now() - dob.getTime();
    const ageDate = new Date(diff);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  };

  const age = calculateAge(birthDate);

  const getPasswordRequirementChecks = (value) => [
    { key: "length", label: "En az 8 karakter", met: value.length >= 8 },
    { key: "maxLength", label: "En fazla 30 karakter", met: value.length <= 30 },
    { key: "uppercase", label: "En az 1 büyük harf", met: /[A-Z]/.test(value) },
    { key: "lowercase", label: "En az 1 küçük harf", met: /[a-z]/.test(value) },
    { key: "special", label: "En az 1 özel karakter", met: /[^a-zA-Z0-9]/.test(value) },
  ];

  const passwordRequirementChecks = getPasswordRequirementChecks(password);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError([]);
    if (passwordRequirementChecks.some((item) => !item.met)) {
      setError(passwordRequirementChecks.filter((item) => !item.met).map((item) => item.label));
      return;
    }
    if (age === null) {
      setError(["Geçerli bir doğum tarihi giriniz."]);
      return;
    }
    if (age <= 5) {
      setError(["Kayıt olmak için 5 yaşından büyük olmalısınız."]);
      return;
    }
    if (age < 15 && age > 5 && !parentEmail.trim()) {
      setError(["15 yaş altı için ebeveyn e-postası gerekli."]);
      return;
    }
    try {
      const payload = { name, email, password, birth_date: birthDate };
      if (age < 15 && age > 5) {
        payload.parent_email = parentEmail.trim();
      }
      const res = await fetch(`${apiUrl}/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (res.ok && data.token) {
        setSuccess(true);
        onAuth(data.token);
      } else {
        const errors = data.missingRequirements || [data.error || data.message || "Kayıt başarısız."];
        setError(Array.isArray(errors) ? errors : [errors]);
      }
    } catch {
      setError(["Sunucu hatası."]);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #e0e7ff 0%, #f7f7f7 100%)",
        padding: 16,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 370,
          background: "#fff",
          padding: "32px 20px",
          borderRadius: 18,
          boxShadow: "0 4px 24px #0002",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontSize: 38,
            fontWeight: 800,
            color: "#3b3b99",
            marginBottom: 8,
            letterSpacing: 1,
            textAlign: "center",
          }}
        >
          <span role="img" aria-label="logo">
            ⏻
          </span>{" "}
          İyiliğin Mucitleri
        </div>
        <h2 style={{ textAlign: "center", marginBottom: 24, color: "#222" }}>
          Kayıt Ol
        </h2>
        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <div style={{ marginBottom: 18 }}>
            <label style={{ fontWeight: 600, color: "#444" }}>Ad Soyad</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              style={{
                width: "100%",
                padding: 10,
                marginTop: 6,
                borderRadius: 8,
                border: "1px solid #d1d5db",
                fontSize: 15,
                outline: "none",
                background: "#f5f7fa",
              }}
              placeholder="Adınız Soyadınız"
            />
          </div>
          <div style={{ marginBottom: 18 }}>
            <label style={{ fontWeight: 600, color: "#444" }}>E-posta</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: "100%",
                padding: 10,
                marginTop: 6,
                borderRadius: 8,
                border: "1px solid #d1d5db",
                fontSize: 15,
                outline: "none",
                background: "#f5f7fa",
              }}
              placeholder="E-posta adresiniz"
            />
          </div>
          <div style={{ marginBottom: 18 }}>
            <label style={{ fontWeight: 600, color: "#444" }}>Doğum Tarihi</label>
            <input
              type="date"
              value={birthDate}
              onChange={(e) => setBirthDate(e.target.value)}
              required
              style={{
                width: "100%",
                padding: 10,
                marginTop: 6,
                borderRadius: 8,
                border: "1px solid #d1d5db",
                fontSize: 15,
                outline: "none",
                background: "#f5f7fa",
              }}
            />
            {age !== null && age <= 5 && (
              <div style={{ fontSize: 12, color: "#e53935", marginTop: 6 }}>
                Kayıt olmak için 5 yaşından büyük olmalısınız.
              </div>
            )}
          </div>
          {age !== null && age > 5 && age < 15 && (
            <div style={{ marginBottom: 18 }}>
              <label style={{ fontWeight: 600, color: "#444" }}>Ebeveyn E-postası</label>
              <input
                type="email"
                value={parentEmail}
                onChange={(e) => setParentEmail(e.target.value)}
                required
                style={{
                  width: "100%",
                  padding: 10,
                  marginTop: 6,
                  borderRadius: 8,
                  border: "1px solid #d1d5db",
                  fontSize: 15,
                  outline: "none",
                  background: "#f5f7fa",
                }}
                placeholder="ebeveyn@example.com"
              />
              <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
                15 yaş altı kayıtlar için ebeveyn onayı amacıyla gereklidir.
              </div>
            </div>
          )}
          <div style={{ marginBottom: 18 }}>
            <label style={{ fontWeight: 600, color: "#444" }}>Şifre</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: "100%",
                padding: 10,
                marginTop: 6,
                borderRadius: 8,
                border: "1px solid #d1d5db",
                fontSize: 15,
                outline: "none",
                background: "#f5f7fa",
              }}
              placeholder="Şifreniz"
            />
            
            <div style={{ marginTop: 10, display: "grid", gap: 8 }}>
              {passwordRequirementChecks.map((requirement) => (
                <div
                  key={requirement.key}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "8px 10px",
                    borderRadius: 8,
                    border: "1px solid",
                    fontSize: 13,
                    fontWeight: 500,
                    color: requirement.met ? "#2f855a" : "#a94442",
                    borderColor: requirement.met ? "#cde6d4" : "#f1c0c0",
                    backgroundColor: requirement.met ? "#f3f8f4" : "#fff5f5",
                  }}
                >
                  <span style={{ width: 16, textAlign: "center", flexShrink: 0 }}>
                    {requirement.met ? "✓" : "•"}
                  </span>
                  <span>{requirement.label}</span>
                </div>
              ))}
            </div>
          </div>
          {error.length > 0 && (
            <div
              style={{
                color: "#e53935",
                marginBottom: 14,
                background: "#ffeaea",
                padding: "8px 12px",
                borderRadius: 6,
                fontSize: 14,
              }}
            >
              <div style={{ fontWeight: 600, marginBottom: 6 }}>Kayıt koşulları sağlanmıyor</div>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                {error.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          )}
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "12px 0",
              background:
                "linear-gradient(90deg, #6366f1 0%, #3b3b99 100%)",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              fontWeight: 700,
              fontSize: 17,
              letterSpacing: 1,
              marginTop: 4,
              boxShadow: "0 2px 8px #6366f122",
              cursor: "pointer",
              transition: "background 0.2s",
            }}
          >
            Kayıt Ol
          </button>
        </form>
        <div
          style={{
            marginTop: 22,
            textAlign: "center",
            fontSize: 15,
            color: "#666",
          }}
        >
          Zaten hesabınız var mı?{" "}
          <Link
            to="/"
            style={{
              color: "#3b3b99",
              textDecoration: "underline",
              fontWeight: 600,
            }}
          >
            Giriş Yap
          </Link>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
